import axios, { AxiosInstance } from 'axios';

export const attachDataExtractInterceptor = (axiosIntance: AxiosInstance = axios) => {
    axiosIntance.interceptors.response.use(response => response.data);
    return axiosIntance;
};
